<template>
	<div class="indexBox">
		<div class="w-full bg-center bg-cover px-8 relative overflow-hidden topBox"
			style="">
			<div class="absolute inset-0 bg-gradient-to-br from-blue-900/80 via-indigo-900/75 to-purple-900/80"></div>
			<div class="flex flex-col items-center w-full pt-24 md:pt-40 pb-20 md:pb-48 relative z-10">
        <img alt="" width="780" height="165" class="max-w-28 absolute top-4 left-4 z-20" style="color:transparent;width: 80px;" src="../../assets/logoW.png">
				
        <div class="font-bold text-3xl md:text-5xl text-white mb-12 md:mb-16 text-center drop-shadow-2xl text-auto">AI数字资产确权中心</div>

				<div class="grid grid-cols-1 md:grid-cols-3 gap-8 w-full max-w-4xl" style="max-width: 1200px;">
					<router-link to="/searchCenter"
						class="BannerCard_bannerCard__8xTj1 relative rounded-2xl pt-6 pb-7 px-8 min-w-0 flex-1 bg-white/15 backdrop-blur-xl cursor-pointer border border-white/20"
						style="box-shadow:0 0 0 1px rgba(255,255,255,0.1), 0 8px 32px rgba(0, 0, 0, 0.3); transition: all 0.3s ease;">
						<span style="outline:none"></span>
						<div class="text-xl font-bold mb-2 text-white">查询中心</div>
						<div class="text-white/70" style="font-size:15px">广告关键词查询、存证核验<br>证书查询、AI资产证书查询<br></div>
						<div class="BannerCard_bannerCardOutline__YdEky absolute text-branding"></div>
					</router-link>
					<router-link to="/chatIndex" target="_blank"
						class="BannerCard_bannerCard__8xTj1 relative rounded-2xl pt-6 pb-7 px-8 min-w-0 flex-1 bg-white/15 backdrop-blur-xl cursor-pointer border border-white/20"
						style="box-shadow:0 0 0 1px rgba(255,255,255,0.1), 0 8px 32px rgba(0, 0, 0, 0.3); transition: all 0.3s ease;">
						<span style="outline:none"></span>
						<div class="text-xl font-bold mb-2 text-white">开始对话</div>
						<div class="text-white/70" style="font-size:15px">顶搜AI融合Deepseek 开启智能新纪元<br>体验全新旗舰模型<br></div>
						<div class="BannerCard_bannerCardOutline__YdEky absolute text-branding"></div>
					</router-link>
					<div href="" target="_blank"
						class="BannerCard_bannerCard__8xTj1 ewmBox relative rounded-2xl pt-6 pb-7 px-8 min-w-0 flex-1 bg-white/15 backdrop-blur-xl cursor-default border border-white/20"
						style="box-shadow:0 0 0 1px rgba(255,255,255,0.1), 0 8px 32px rgba(0, 0, 0, 0.3); transition: all 0.3s ease;">
						<span style="outline:none"></span>
						<div class="text-xl font-bold mb-2 text-white text-auto">获取手机 App</div>
						<div class="text-white/70 text-auto" style="font-size:15px">顶搜 官方推出的免费 AI 助手<br>搜索写作阅读解题翻译工具<br></div>
						<div class="BannerCard_bannerCardOutline__YdEky absolute text-branding"></div>
						<div class="ds-floating-position-wrapper ds-theme downEwm" style="z-index: 1024;">
							<div class="ds-tooltip ds-tooltip--m ds-tooltip--show-shadow ds-elevated ds-theme">
								<div class="text-center mt-2 mb">
									<div class="ds-qr-code"
										style="background-color: rgb(255, 255, 255); width: 200px; height: 200px; box-sizing: content-box;">
										<img src="@/assets/dingsoEwm.png">
									</div>
									<div><span class="text-slate-600 font-semibold">扫码下载 顶搜 APP</span></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="flex gap-6 !absolute right-6 top-4 z-20">
				<router-link to="/searchCenter" class="ds-a ds-a--link text-sm !text-white/80 cursor-pointer hover:!text-white transition-colors">
					<span aria-hidden="true" style="position:fixed;user-select:none;-ms-user-select:none;-webkit-user-select:none;-moz-user-select:none;opacity:0;width:0;height:0;display:block"></span>查询中心
				</router-link>
				<router-link to="/chatIndex" v-if="userName==''" hreflang="en"
					class="ds-a ds-a--link text-sm !text-white/80 cursor-pointer hover:!text-white transition-colors" href="#"><span aria-hidden="true"
						style="position:fixed;user-select:none;-ms-user-select:none;-webkit-user-select:none;-moz-user-select:none;opacity:0;width:0;height:0;display:block"></span>登录/注册</router-link>
				<router-link to="/chatIndex" v-else hreflang="en"
					class="ds-a ds-a--link text-sm !text-white/80 cursor-pointer hover:!text-white transition-colors" href="#"><span aria-hidden="true"
						style="position:fixed;user-select:none;-ms-user-select:none;-webkit-user-select:none;-moz-user-select:none;opacity:0;width:0;height:0;display:block"></span>{{userName}}</router-link>
			</div>
		</div>

		<div id="about-section">
			
			<section class="about-section" data-section="hero">
				<div class="section-content">
					<h1 class="section-title">关于我们</h1>
					<p class="section-subtitle">打造国内领先的数字资产确权与合规服务平台</p>
				</div>
			</section>

			<section class="about-section" data-section="intro">
				<div class="section-content">
					<div class="text-content">
						<h2 class="section-title">AI数字资产确权中心</h2>
						<p class="section-desc">
							由北京亿联星空技术有限公司倾力打造，是国内领先的数字资产确权与合规服务平台。
						</p>
						<p class="section-desc">
							依托公司强大的技术研发实力与行业资源整合能力，我们全面携手与中国版权保护中心DCI体系、人民链及司法联盟链共同发起AI数字资产确权中心，形成"技术+权威+合规"三位一体的一站式数字资产服务生态，致力于为各类主体提供权威、合规、可落地的数字资产确权、存证、维权及交易全流程解决方案，助力数字经济高质量发展。
						</p>
					</div>
					<div class="image-content">
						<div class="image-wrapper">
							<svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
								<circle cx="100" cy="100" r="80" stroke="rgba(255,255,255,0.3)" stroke-width="2" fill="none"/>
								<path d="M70 100 L90 120 L130 80" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
						</div>
					</div>
				</div>
			</section>

			<section class="about-section" data-section="position">
				<div class="section-content">
					<div class="image-content">
						<div class="image-wrapper">
							<svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M100 20 L120 60 L180 60 L130 90 L150 140 L100 110 L50 140 L70 90 L20 60 L80 60 Z" stroke="#3b82f6" stroke-width="2" fill="rgba(59, 130, 246, 0.1)"/>
							</svg>
						</div>
					</div>
					<div class="text-content">
						<h2 class="section-title">我们的核心定位</h2>
						<p class="section-desc">
							以AI技术为驱动，以权威合规为基石，以全链条服务为核心，打破数字资产确权难、存证弱、维权繁、交易乱的行业痛点，成为数字资产安全保护与合规流通的标杆平台。
						</p>
						<p class="section-desc">
							我们坚守"技术赋能权益，合规护航价值"的理念，让每一份数字资产都能获得清晰权属、安全存证、便捷维权与合规变现，推动数字资产从"资源"向"资本"转化。
						</p>
					</div>
				</div>
			</section>

			<section class="about-section" data-section="partners">
				<div class="section-content">
					<div style="text-align: center; margin-bottom: 3rem;">
						<h2 class="section-title">权威合作</h2>
						<p class="section-subtitle">北京亿联星空技术有限公司深度携手行业权威机构，构建多方协同的合规服务体系</p>
					</div>
					<div class="partners-grid">
						<div class="partner-card">
							<h3 class="partner-title">中国版权保护中心DCI体系</h3>
							<p class="partner-desc">全面接入国家版权局认可的DCI数字版权唯一标识符体系，严格遵循行业标准，为数字作品提供官方认可的确权服务。</p>
						</div>
						<div class="partner-card">
							<h3 class="partner-title">人民网·人民数据</h3>
							<p class="partner-desc">接入人民链基础设施，实现数据资产"三证"上链，确保数据资产权属清晰、不可篡改。</p>
						</div>
						<div class="partner-card">
							<h3 class="partner-title">司法联盟链</h3>
							<p class="partner-desc">联动互联网法院、公证处、司法鉴定机构，实现存证数据与司法体系无缝对接。</p>
						</div>
						<div class="partner-card">
							<h3 class="partner-title">持牌交易所</h3>
							<p class="partner-desc">对接北京数据交易所、上海数据交易所等持牌机构，构建"确权-存证-交易"合规闭环。</p>
						</div>
					</div>
				</div>
			</section>

			<section class="about-section" data-section="services">
				<div class="section-content">
					<div style="text-align: center; margin-bottom: 3rem;">
						<h2 class="section-title">核心服务</h2>
						<p class="section-subtitle">我们聚焦数字资产全生命周期管理，打造7大核心服务</p>
					</div>
					<div class="services-grid">
						<div v-for="(service, index) in serviceList" :key="index" class="service-card">
							<div class="service-number">{{ index + 1 }}</div>
							<h3 class="service-title">{{ service.title }}</h3>
							<p class="service-desc">{{ service.desc }}</p>
						</div>
					</div>
				</div>
			</section>

			<section class="about-section" data-section="vision">
				<div class="section-content">
					<div class="vision-card">
						<h2 class="section-title">愿景与使命</h2>
						<div class="mission-block">
							<h3>使命</h3>
							<p class="section-desc">以技术创新赋能数字资产保护，以合规服务护航数字经济发展，让每一份数字创造都能得到尊重与保障，让数字资产价值充分释放。</p>
						</div>
						<div class="vision-block">
							<h3>愿景</h3>
							<p class="section-desc">成为国内数字资产确权与合规服务领域的领军平台，推动建立规范、有序、高效的数字资产治理体系，助力我国数字经济高质量发展。</p>
						</div>
					</div>
					<div class="contact-card">
						<h2 class="section-title">联系我们</h2>
						<p class="section-desc">如果您有数字资产确权、存证、维权或交易相关需求，欢迎联系我们。</p>
						<div class="contact-info">
							<div class="contact-item">
								<div class="contact-label">微信号</div>
								<div class="contact-value">13520051855</div>
							</div>
							<div class="contact-item">
								<div class="contact-label">渠道招商热线</div>
								<div class="contact-value">13520051855</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>

		<div class="w-full relative">
			<div class="flex flex-col items-center w-full text-base"></div>
			<div class="border-t-1 pt-16 border-slate-200 px-8">
				<div class="" style="font-size:15px;padding-bottom: 2rem;">
					<div class="flex flex-col gap-2 col-span-1 sm:col-span-2 order-last xl:order-first items-center">
            <img class="max-w-40 mt-1 mb-6" style="color:transparent;width: 100px;margin: auto;" src="../../assets/logoN.png">
							<div class="flex flex-col gap-3 items-center" style="margin: auto;">
								<div class="text-sm mt-6 text-slate-400 text-center text-c" >技术运维单位：北京亿联星空技术有限公司</div>
								<a href="https://beian.miit.gov.cn/" target="_blank" class="ds-a ds-a--link text-sm !text-slate-400 text-center text-c">
                <span aria-hidden="true" style="position:fixed;user-select:none;-ms-user-select:none;-webkit-user-select:none;-moz-user-select:none;opacity:0;width:0;height:0;display:block"></span>渝ICP备19005330号
              </a>
								<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50011202502819" target="_blank" class="ds-a ds-a--link text-sm !text-slate-400 text-center text-c">
                <span aria-hidden="true" style="position:fixed;user-select:none;-ms-user-select:none;-webkit-user-select:none;-moz-user-select:none;opacity:0;width:0;height:0;display:block"></span>渝公网安备 50011202502819号
              </a>
							</div>
						</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { message } from 'ant-design-vue'

	export default {
		data() {
			return {
				userName: '',
				serviceList: [
					{ title: 'AI生成内容确权', desc: '针对AI生成文字、图片、音频、视频等内容，自动生成DCI数字版权唯一标识，快速完成国家版权登记，颁发电子登记证书，权属信息终身可在线查验，从源头锁定创作成果权益。' },
					{ title: '区块链存证固证', desc: '采用人民链+司法联盟链双上链模式，结合哈希加密与可信时间戳技术，对数字资产进行实时存证，实现数据不可篡改、可追溯，存证结果具备司法效力，为权益保障提供坚实支撑。' },
					{ title: 'AI内容合规审核', desc: '前置风控审核机制，通过AI智能算法过滤侵权、违规等不合规内容，提前规避确权风险，确保数字资产符合国家法律法规及行业规范，保障确权流程顺利推进。' },
					{ title: '权属核验与溯源', desc: '提供实时接口查询服务，支持快速查验数字资产的权属信息、流转记录，可嵌入各类平台实现一键查验，让权属状态透明可查，降低交易风险。' },
					{ title: '侵权取证与维权', desc: '发现侵权行为时，自动完成侵权证据固证、在线出证，直接对接司法维权通道，简化维权流程、降低维权成本，高效保护权利人合法权益。' },
					{ title: '数据资产三证登记', desc: '遵循权威标准，为数据资产办理数据资源持有权、加工使用权、产品经营权三证登记并实现上链存证，明确数据资产权益归属，为数据流通、融资等场景提供官方凭证。' },
					{ title: '合规交易撮合', desc: '依托持牌交易所资源，为确权后的数字资产提供合规交易撮合服务，打通数字资产流通变现通道，实现"确权-交易-结算"全流程合规闭环，助力数字资产价值最大化。' }
				]
			}
		},
		mounted() {
			if (localStorage.getItem('token')) {
				this.userName = localStorage.getItem('userName')
			}
			this.initScrollAnimations()
		},
		methods: {
			initScrollAnimations() {
				const sections = document.querySelectorAll('.about-section')
				
				const observerOptions = {
					root: null,
					rootMargin: '0px',
					threshold: 0.2
				}
				
				const observer = new IntersectionObserver((entries) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							entry.target.classList.add('visible')
						}
					})
				}, observerOptions)
				
				sections.forEach(section => {
					observer.observe(section)
				})
			}
		}
	}
</script>

<style scoped>
	@import url('../../style/index (2).css');
	
	.topBox {
		background: url('../../assets/top.jpg') no-repeat;
		background-size: cover;
	}

	.BannerCard_bannerCard__8xTj1:hover {
		transform: translateY(-8px);
		box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4) !important;
		background: rgba(255, 255, 255, 0.25) !important;
	}
	
	#about-section {
		width: 100%;
	}
	
	.about-section {
		min-height: 80vh;
		display: flex;
		align-items: center;
		justify-content: center;
		opacity: 0;
		transform: translateY(40px);
		transition: all 0.8s cubic-bezier(0.16, 1, 0.3, 1);
	}
	
	.about-section.visible {
		opacity: 1;
		transform: translateY(0);
	}
	
	.about-section[data-section="hero"] {
		min-height: 40vh;
		background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
	}
	
	.about-section[data-section="hero"] .section-content {
		text-align: center;
		padding: 4rem 1.5rem;
	}
	
	.about-section[data-section="intro"] {
		background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
	}
	
	.about-section[data-section="position"] {
		background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
	}
	
	.about-section[data-section="partners"] {
		min-height: 100vh;
		background: linear-gradient(135deg, #7c3aed 0%, #5b21b6 100%);
	}
	
	.about-section[data-section="services"] {
		min-height: 100vh;
		background: linear-gradient(135deg, #020617 0%, #1e293b 100%);
	}
	
	.about-section[data-section="vision"] {
		background: linear-gradient(135deg, #3b82f6 0%, #7c3aed 100%);
	}
	
	.section-content {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 4rem;
		max-width: 75rem;
		margin: 0 auto;
		padding: 4rem 1.5rem;
		width: 100%;
	}
	
	.about-section[data-section="partners"] .section-content,
	.about-section[data-section="services"] .section-content {
		grid-template-columns: 1fr;
		display: block;
	}
	
	.about-section[data-section="hero"] .section-content {
		grid-template-columns: 1fr;
		display: block;
	}
	
	.text-content {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.section-title {
		font-size: clamp(1.75rem, 3vw, 2.5rem);
		font-weight: 700;
		color: #fff;
		margin-bottom: 1.5rem;
		line-height: 1.2;
		transition: all 0.3s ease;
	}
	
	.section-title:hover {
		transform: translateX(8px);
		color: rgba(255, 255, 255, 0.95);
	}
	
	.section-subtitle {
		font-size: clamp(1rem, 1.5vw, 1.125rem);
		color: rgba(255, 255, 255, 0.7);
		max-width: 36rem;
		margin: 0 auto;
	}
	
	.section-desc {
		font-size: clamp(1rem, 1.5vw, 1.125rem);
		color: rgba(255, 255, 255, 0.9);
		line-height: 1.75;
		margin-bottom: 1rem;
		transition: all 0.3s ease;
	}
	
	.section-desc:hover {
		color: rgba(255, 255, 255, 1);
		transform: translateX(4px);
	}
	
	.image-content {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.image-wrapper {
		width: 100%;
		max-width: 28rem;
		aspect-ratio: 1;
		border-radius: 1.5rem;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: all 0.5s ease;
	}
	
	.about-section[data-section="intro"] .image-wrapper {
		background: rgba(255, 255, 255, 0.1);
		backdrop-filter: blur(10px);
	}
	
	.about-section[data-section="position"] .image-wrapper {
		background: linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(139, 92, 246, 0.2) 100%);
		backdrop-filter: blur(10px);
	}
	
	.image-wrapper:hover {
		transform: scale(1.05);
	}
	
	.partners-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(15rem, 1fr));
		gap: 1.5rem;
	}
	
	.partner-card {
		background: rgba(255, 255, 255, 0.1);
		backdrop-filter: blur(10px);
		border-radius: 1rem;
		padding: 2rem;
		transition: all 0.3s ease;
	}
	
	.partner-card:hover {
		background: rgba(255, 255, 255, 0.18);
		transform: translateY(-8px);
	}
	
	.partner-title {
		font-size: 1.125rem;
		font-weight: 600;
		color: #fff;
		margin-bottom: 0.75rem;
		transition: all 0.3s ease;
	}
	
	.partner-card:hover .partner-title {
		color: rgba(255, 255, 255, 1);
		transform: translateX(4px);
	}
	
	.partner-desc {
		font-size: 0.9375rem;
		color: rgba(255, 255, 255, 0.8);
		line-height: 1.6;
		transition: all 0.3s ease;
	}
	
	.partner-card:hover .partner-desc {
		color: rgba(255, 255, 255, 0.95);
	}
	
	.services-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(18rem, 1fr));
		gap: 1.5rem;
	}
	
	.service-card {
		background: linear-gradient(135deg, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 0.8) 100%);
		border: 1px solid rgba(59, 130, 246, 0.2);
		border-radius: 1rem;
		padding: 2rem;
		transition: all 0.3s ease;
	}
	
	.service-card:hover {
		border-color: rgba(59, 130, 246, 0.5);
		transform: translateY(-8px);
		background: linear-gradient(135deg, rgba(30, 41, 59, 0.95) 0%, rgba(15, 23, 42, 0.95) 100%);
	}
	
	.service-number {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 2.5rem;
		height: 2.5rem;
		background: rgba(59, 130, 246, 0.2);
		color: #3b82f6;
		font-weight: 700;
		border-radius: 0.5rem;
		margin-bottom: 1rem;
		transition: all 0.3s ease;
	}
	
	.service-card:hover .service-number {
		background: #3b82f6;
		color: #fff;
		transform: scale(1.1);
	}
	
	.service-title {
		font-size: 1.125rem;
		font-weight: 600;
		color: #fff;
		margin-bottom: 0.75rem;
		transition: all 0.3s ease;
	}
	
	.service-card:hover .service-title {
		color: #3b82f6;
		transform: translateX(4px);
	}
	
	.service-desc {
		font-size: 0.9375rem;
		color: rgba(255, 255, 255, 0.7);
		line-height: 1.6;
		transition: all 0.3s ease;
	}
	
	.service-card:hover .service-desc {
		color: rgba(255, 255, 255, 0.9);
	}
	
	.vision-card,
	.contact-card {
		background: rgba(255, 255, 255, 0.1);
		backdrop-filter: blur(10px);
		border-radius: 1.5rem;
		padding: 2.5rem;
		transition: all 0.3s ease;
	}
	
	.contact-card {
		background: rgba(255, 255, 255, 0.15);
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.contact-info {
		margin-top: 1.5rem;
		display: flex;
		flex-direction: column;
		gap: 1.25rem;
	}
	
	.contact-item {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
	}
	
	.contact-label {
		font-size: 0.9375rem;
		font-weight: 600;
		color: rgba(255, 255, 255, 0.95);
	}
	
	.contact-value {
		font-size: 1.25rem;
		font-weight: 700;
		color: #fff;
		background: rgba(255, 255, 255, 0.1);
		padding: 0.75rem 1.25rem;
		border-radius: 0.75rem;
		letter-spacing: 0.05em;
		transition: all 0.3s ease;
	}
	
	.contact-value:hover {
		background: rgba(255, 255, 255, 0.2);
		transform: translateX(4px);
	}
	
	.vision-card:hover,
	.contact-card:hover {
		transform: translateY(-8px);
	}
	
	.mission-block,
	.vision-block {
		margin-bottom: 1.5rem;
	}
	
	.vision-block {
		margin-bottom: 0;
	}
	
	.vision-card h3 {
		font-size: 1.125rem;
		font-weight: 600;
		color: rgba(255, 255, 255, 0.9);
		margin-bottom: 0.5rem;
		transition: all 0.3s ease;
	}
	
	.vision-card:hover h3 {
		transform: translateX(4px);
		color: rgba(255, 255, 255, 1);
	}
	
	.contact-btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 0.5rem;
		padding: 1rem 2rem;
		background: #fff;
		color: #3b82f6;
		font-weight: 600;
		border-radius: 0.75rem;
		text-decoration: none;
		transition: all 0.3s ease;
		width: fit-content;
	}
	
	.contact-btn:hover {
		transform: scale(1.05);
		box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
		background: rgba(255, 255, 255, 0.95);
	}
	
	@media screen and (max-width: 768px) {
		.section-content {
			grid-template-columns: 1fr;
			gap: 2rem;
		}
		
		.about-section[data-section="position"] .section-content {
			direction: ltr;
		}
		
		.about-section[data-section="position"] .image-content {
			order: -1;
		}
		
		.section-content {
			padding: 3rem 1rem;
		}
		
		.partners-grid,
		.services-grid {
			grid-template-columns: 1fr;
		}
	}
	
	@media screen and (max-width: 767px) {
		.indexBox > div:first-child {
			padding-top: 5rem !important;
		}
		
		.indexBox > div:first-child > img {
			position: absolute !important;
			top: 1rem !important;
			left: 1rem !important;
			width: 60px !important;
			z-index: 30 !important;
		}
		
		.indexBox > div:first-child > div:last-child {
			position: absolute !important;
			top: 1rem !important;
			right: 1rem !important;
			gap: 0.75rem !important;
			z-index: 30 !important;
		}
		
		.indexBox > div:first-child > div:last-child a {
			font-size: 0.8rem !important;
		}
		
		.indexBox > div:first-child > div:nth-child(2) {
			padding-top: 6rem !important;
		}
		
		.indexBox > div:first-child > div:nth-child(2) > div:first-child {
			font-size: 1.75rem !important;
			margin-bottom: 2rem !important;
		}
		
		.indexBox > div:first-child > div:nth-child(2) > div:last-child {
			grid-template-columns: 1fr !important;
			gap: 1rem !important;
			padding: 0 0.5rem !important;
		}
	}
	
	a,.mx-auto,.text-auto{
		color: white !important;
	}
	.text-c{
		color: rgba(0, 0, 0, 0.65) !important;
	}
	.downEwm {
		position: absolute;
		background-color: #fff;
		border-radius: 10px;
		padding: 10px;
		top: -260px;
		left: 50%;
		transform: translateX(-50%);
		box-shadow: 0 6px 16px 0 rgba(0, 0, 0, .08), 0 3px 6px -4px rgba(0, 0, 0, .12), 0 9px 28px 8px rgba(0, 0, 0, .05);
		transition: 0.5s;
		display: none;
	}
	.ewmBox:hover .downEwm { display: block; }
	.inputBox { display: flex; justify-content: space-between; width: 800px; margin: 0 auto; }
	.zhengshu { width: 800px; margin: 0 auto; }
	.serchBox { width: 390px; display: flex; margin-bottom: 30px; }
	.zsBox { width: 800px !important; }
	.zsBox input { width: 650px !important; }
	.zsBtn { width: 150px !important; }
	.serchBox input {
		width: 310px; height: 48px; box-sizing: border-box; background: #fff; border-radius: 6px 0 0 6px; border: none;
		outline: none; padding-left: 20px; font-size: 14px; color: #191a24;
	}
	.P2A_K1AX {
		background: #2468f2; border-radius: 0 6px 6px 0; font-family: PingFangSC-Regular; font-size: 16px; color: #fff;
		height: 48px; width: 80px; letter-spacing: 0; text-align: center; line-height: 48px; cursor: pointer; display: block;
	}
	@media screen and (max-width: 767px) {
		.inputBox, .zhengshu { max-width: 100%; display: block; }
		.serchBox { max-width: 100%; }
		.serchBox input { height: 42px; }
		.P2A_K1AX { height: 42px; line-height: 42px; font-size: 14px; white-space: nowrap; }
		.zsBtn { width: 180px !important; font-size: 13px !important; }
	}
	.hyInfoBox .ant-modal-content { border-radius: 10px !important; }
	.hyInfoBox .ant-modal .ant-modal-body { background-image: linear-gradient(180deg, #dae5fd, #fff); background-repeat: no-repeat; background-size: 100% 150px; border-radius: 10px; }
	.hyImg { text-align: center; padding-top: 20px; }
	.hyImg img { width: 50px; margin: auto; }
	.hyTip { font-size: 20px; font-weight: 700; line-height: 40px; margin-top: 15px; }
	.hyF { font-size: 16px; }
	.hyLoading { text-align: center; }
	.hyLoading img { width: 300px; margin: auto; }
	.hyLine { border: none; border-bottom: 1px solid #e7eaef; margin: 20px 0; padding: 0; }
	.hyDet { display: table; font-size: 12px; line-height: 1.5; }
	.hyItem { display: table-row; }
	.hyLab { padding-right: 20px; padding-top: 6px; vertical-align: initial; display: table-cell; }
	.hyText { word-wrap: break-word; color: #000; padding-right: 12px; width: 100%; word-break: break-word; }
</style>
